export default "__VITE_ASSET__BqwfYacO__"